import dataSelect from '@store/dataForSelect/reducers';

import { subject_select } from '../../configs/constants';

export default dataSelect(subject_select);
